import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../../shared/ApiService";
import { DocumentMetadataDto } from "./DocumentMetadataDto";

@Injectable()
export class DocumentPickerService {
  private apiService = inject(ApiService);

  public UploadFile(file: File): Observable<DocumentMetadataDto> {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);

    const headers = new Headers();
    headers.append("Content-type", "multipart/form-data");
    headers.append("Accept", "application/json");
    return this.apiService.POST(formData, "api/v1/documents");
  }
}
